import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import flagIcon from "../../../Images/image/flagIcon.png";
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const reportedAds = permission.find((o) => o.slug === "reported_ads");
const reportedUsers = permission.find((o) => o.slug === "reported_users");
const flaggedReview = permission.find((o) => o.slug === "flagged_review");


const ReportedSubMenu = () => {

    const hasReadPermissionForReportedAds = reportedAds?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForReportedUsers = reportedUsers?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForFlaggedReview = flaggedReview?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForReportedAds &&
        !hasReadPermissionForReportedUsers &&
        !hasReadPermissionForFlaggedReview) {
        return null
    }


    return (
        <>
            <Tooltip title='Reports and Flags' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <img src={flagIcon} alt="" role="button" />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>

                    {/* Reported Ads */}
                    {hasReadPermissionForReportedAds &&
                        <TextLink
                            to="/reported-ads"
                            onClick={handleClose}
                        >
                            Reported Ads
                        </TextLink>
                    }

                    {/* Reported Chats */}
                    {hasReadPermissionForReportedUsers &&
                        <>
                            <TextLink
                                to="/reported-chats"
                                onClick={handleClose}
                            >
                                Reported Chats
                            </TextLink>
                            <TextLink
                                to="/flagged-data"
                                onClick={handleClose}
                            >
                                Flagged Data
                            </TextLink>
                        </>
                    }

                    {hasReadPermissionForFlaggedReview &&
                        <TextLink
                            to="/flagged-review"
                            onClick={handleClose}
                        >
                            Flagged Review
                        </TextLink>
                    }

                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default ReportedSubMenu